import { render } from "./SectionNavigationComponent.vue?vue&type=template&id=6f21d07a"
import script from "./SectionNavigationComponent.vue?vue&type=script&lang=js"
export * from "./SectionNavigationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__